import apiClient from './api';

export interface MeituanOrderConfirmLog {
  id: string;
  callbackId: string;
  reservationId: string;
  serviceOrderId: string;
  serviceOrderNo: string;
  meituanOrderId: string;
  appOrderId: string;
  shopId: string;
  opPoiId: string;
  appAuthToken: string;
  autoAcceptOrder: number;
  result: number;
  status: string;
  requestPayload: string;
  responsePayload: string;
  errorMessage: string;
  confirmedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanOrderConfirmLogListParams {
  page?: number;
  pageSize?: number;
  serviceOrderNo?: string;
  serviceOrderId?: string;
  meituanOrderId?: string;
  appOrderId?: string;
  shopId?: string;
  opPoiId?: string;
  result?: string;
  status?: string;
  startTime?: string;
  endTime?: string;
}

export const listMeituanOrderConfirmLogs = (params: MeituanOrderConfirmLogListParams) => (
  apiClient.get<{ list: MeituanOrderConfirmLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/order-confirm-logs',
    { params },
  )
);
